import { useId, forwardRef } from "react";
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";
import { handleSidebarListingHover } from "@/src/store/hoveredListing";

import { getQuickInfoList } from "src/helpers/map/listing-cards";
import { formatPrice } from "src/helpers/map/commons";

import { LazyImage } from "src/components/common/lazy-image/LazyImage";

import styles from "../styles.module.css";

export const ListingListMapCard = forwardRef(({ informations, isLandPage }, ref) => {
  const { title, imagesFullPath, quickInfos, priceDetail, tradeTypeName, url, id } = informations || {};
  /* const isFirstDisplayedListingCard = [0, 1, 2, 3, 4].includes(index); */
  const dispatch = useDispatch();

  const squareMeterPrice =
    isLandPage && quickInfos?.find((quickInfo) => quickInfo?.key === "square_meter_price")?.value;
  const quickInfoList = getQuickInfoList(informations);

  return (
    <a
      ref={ref}
      href={url}
      target="_blank"
      className={styles.container}
      rel="noreferrer"
      onMouseEnter={() => dispatch(handleSidebarListingHover(id))}
      onMouseLeave={() => dispatch(handleSidebarListingHover(null))}
      id={`listingItem-${id}`}
    >
      <div className={styles.imageWrapper}>
        <LazyImage
          src={imagesFullPath?.[0]}
          alt={imagesFullPath?.[0]}
          className={styles.image}
          width="80px"
          /* visibleByDefault={isFirstDisplayedListingCard} */
        />
      </div>
      <div className={styles.listingInfoWrapper}>
        <p className={styles.listingInfoTitle}>{title}</p>
        <div className={styles.quickInfoList}>
          <>
            {quickInfoList.map((quickInfo) => (
              <span className={styles.quickInfoItem} key={useId()}>
                {quickInfo}
              </span>
            ))}
            {isLandPage && squareMeterPrice && <span className={styles.quickInfoItem}> - {squareMeterPrice}</span>}
          </>
        </div>
        <div className={styles.listingInfoPrice}>{formatPrice(priceDetail, tradeTypeName)}</div>
      </div>
    </a>
  );
});

ListingListMapCard.propTypes = {
  informations: PropTypes.object,
  isLandPage: PropTypes.bool,
};

ListingListMapCard.displayName = "ListingListMapCard";
